import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles
const style = document.createElement('style');
style.textContent = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0d1b3e; color: #ffffff; font-family: 'IBM Plex Mono', 'Courier New', monospace; }
  ::-webkit-scrollbar { width: 6px; height: 6px; }
  ::-webkit-scrollbar-track { background: #0d1b3e; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,.14); border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background: #444c56; }
  a { color: inherit; }
  input:focus { border-color: #f5a623 !important; }
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: .6; }
  }
  /* Leaflet dark theme overrides */
  .leaflet-popup-content-wrapper {
    background: #10224a !important;
    border: 1px solid rgba(255,255,255,.14) !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 20px rgba(0,0,0,.5) !important;
    color: #ffffff !important;
  }
  .leaflet-popup-tip { background: #10224a !important; }
  .leaflet-popup-content { margin: 10px 14px !important; }
  .leaflet-container { font-family: 'IBM Plex Mono', monospace !important; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
